import { render, staticRenderFns } from "./Ventilation.vue?vue&type=template&id=07135ed8"
import script from "./Ventilation.vue?vue&type=script&lang=js"
export * from "./Ventilation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports